/**
 * Shown instead of a result when an input the topic risk could use is not activated for the
 * organization. Only a solution admin can activate one, so everyone else gets a disabled
 * button explaining why.
 */
import Permissions, { usePermissions } from '@app/src/auth/permissions'
import { useDrawer } from '@app/src/components/Drawer/DrawerContext'
import type { CONFIGURATION_PAGE_IDS } from '@app/src/pages/Configurations/ConfigurationsScene'
import paths from '@app/src/wf-constants/paths'
import { Button, Tooltip } from '@mui/material'
import React from 'react'
import { useIntl } from 'react-intl'
import { generatePath } from 'react-router'
import { useHistory } from 'react-router-dom'

export interface ActivateInConfigurationButtonProps {
  configurationsPage: CONFIGURATION_PAGE_IDS
  noAccessTooltipId: string
}

export const ActivateInConfigurationButton: React.FC<ActivateInConfigurationButtonProps> = ({
  configurationsPage,
  noAccessTooltipId,
}) => {
  const { formatMessage } = useIntl()
  const { hasPermission } = usePermissions()
  const { closeDrawer } = useDrawer()
  const history = useHistory()

  const isAdmin = hasPermission(Permissions.ACCESS_SOLUTION_CONFIGURATION)

  const goToConfiguration = () => {
    closeDrawer()
    history.push(generatePath(paths.configurations, { configurationsPage }))
  }

  return (
    <Tooltip arrow title={isAdmin ? '' : formatMessage({ id: noAccessTooltipId })} disableHoverListener={isAdmin}>
      <span>
        <Button variant="text" size="small" disabled={!isAdmin} onClick={goToConfiguration}>
          {formatMessage({ id: 'topicalRisk.drawer.activate' })}
        </Button>
      </span>
    </Tooltip>
  )
}

export default ActivateInConfigurationButton
